import { createSlice } from '@reduxjs/toolkit';
import { Manufacturer } from 'src/constants/inventory';
import * as thunks from './thunks';
import { PaginationV2 } from 'src/types';
import { ManufacturerDetails } from './types';

type State = {
  manufacturers: Manufacturer[];
  manufacturerDetails: ManufacturerDetails;
  manufacturersOnFilter: Manufacturer[];
  meta: PaginationV2;
};

const initialState: State = {
  manufacturers: [],
  manufacturerDetails: {
    id: 0,
    name: '',
    remarks: '',
    brand_display_from: null,
    brand_display_to: null,
    created_at: '',
    updated_at: '',
    icon_url: '',
    banner_url: '',
    warranty_details: ''
  },
  manufacturersOnFilter: [],
  meta: {
    current_page: 1
  }
};

const setManufacturerDetails = (
  state: State,
  { payload }: { payload: ManufacturerDetails }
) => {
  if (payload) state.manufacturerDetails = payload;
};

const updateManufacturerDetails = (
  state: State,
  // eslint-disable-next-line no-undef
  { payload }: { payload: Partial<ManufacturerDetails> }
) => {
  state.manufacturerDetails = {
    ...state.manufacturerDetails,
    ...payload
  };
};

const slice = createSlice({
  name: 'manufacturers',
  initialState,
  reducers: {
    setManufacturerDetails,
    updateManufacturerDetails
  },
  extraReducers(builder) {
    builder.addCase(
      thunks.getManufacturersThunk.fulfilled,
      (state, { payload }) => {
        state.manufacturers = Array.isArray(payload?.originalData?.data)
          ? payload.originalData.data.map((item) => ({
              id: item?.id ?? 0,
              name: item?.name ?? '',
              is_end_date: item?.is_end_date ?? false
            }))
          : [];
        state.meta = payload.originalData.meta;
      }
    );

    builder.addCase(
      thunks.getManufacturersFilterThunk.fulfilled,
      (state, { payload }) => {
        state.manufacturersOnFilter = payload.originalData.data?.map(
          (item) => ({
            ...item,
            id: item.id ?? 0,
            name: item.name ?? ''
          })
        );
      }
    );

    builder.addCase(
      thunks.getManufacturerViaIdThunk.fulfilled,
      (state, { payload }) => {
        const manufacturer = payload.originalData.manufacturer;
        state.manufacturerDetails = {
          ...state.manufacturerDetails,
          ...manufacturer
          // brand_display_from: manufacturer.brand_display_from
          //   ? typeof manufacturer.brand_display_from === 'string'
          //     ? new Date(manufacturer.brand_display_from)
          //     : manufacturer.brand_display_from
          //   : null,
          // brand_display_to: manufacturer.brand_display_to
          //   ? typeof manufacturer.brand_display_to === 'string'
          //     ? new Date(manufacturer.brand_display_to)
          //     : manufacturer.brand_display_to
          //   : null
        };
      }
    );
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
